<template>
    <div>
        <v-row>
            <v-col cols="10" class="title">
                <slot>

                </slot>
            </v-col>
            <v-col cols="2">
                <img
              src="https://climate-rx.s3.us-west-1.amazonaws.com/logo.png"
              alt="logo"
              class="logo"
            />
            </v-col>
        
            <v-col cols="12">
                <hr />
            </v-col>
        </v-row>
    </div>
</template>
<script>
export default {
}
</script>
<style>
    .title {
        color: #283891;
        text-align: left;
    }

    .logo {
        width: 100px;
        height: auto;
        margin-left: auto;
        margin-right: 10px;
    }
    
    hr {
        border: none;
        border-top: 1px solid #283891;
        margin: 5px 0;
        width: 98%;
    }
</style>